<div class="modal-header">
    <h2 class="modal-title mat-dialog-title" mat-dialog-title trans>Select Roles</h2>
    <button type="button" (click)="close()" class="close-button no-style icon-button"><mat-icon svgIcon="close"></mat-icon></button>
</div>

<form (ngSubmit)="confirm()" ngNativeValidate>
    <div class="mat-dialog-content" mat-dialog-content>
        <mat-selection-list (selectionChange)="toggleSelectedRole($event)">
            <ng-container *ngFor="let role of roles">
                <mat-list-option
                        *ngIf="!role.guests"
                        [value]="role.id"
                        [disabled]="isRoleDisabled(role.id)"
                        [selected]="isRoleSelected(role.id)"
                >{{role.name}}</mat-list-option>
            </ng-container>
        </mat-selection-list>
    </div>

    <div class="buttons right mat-dialog-actions" mat-dialog-actions>
        <button (click)="close()" mat-button type="button" class="button cancel" trans>Cancel</button>
        <button type="submit" mat-raised-button color="accent" class="button primary submit-button" trans>Select</button>
    </div>
</form>
